import { element$ } from './element';
import { ElementOptions } from './element.options';

type ElementType = HTMLDivElement;
export type DivElementOptions = ElementOptions<ElementType> & {};
type Options = DivElementOptions;

export function div$(): ElementType;
export function div$(classes: string): ElementType;
export function div$(classes: string, children: Element[]): ElementType;
export function div$(classes: string, options: Options): ElementType;
export function div$(
  classes: string,
  options: Options,
  children: Element[]
): ElementType;
export function div$(children: Element[]): ElementType;
export function div$(options: Options): ElementType;
export function div$(options: Options, children: Element[]): ElementType;
export function div$(
  arg1?: Options | Element[] | string,
  arg2?: Options | Element[],
  arg3?: Element[]
): ElementType {
  return element$('div', arg1, arg2, arg3);
}
